<ic-auth-wrapper>
	<ic-organisation-form
		[errorForInput]="currentOrganisation"
		[errorLabel]="errorLabel$ | async"
		[loading]="loading$ | async"
		(selectOrganisation)="selectOrganisation($event)"
	>
		@if (error$ | async) {
			<p class="message error"><i class="fa fa-exclamation-triangle"></i> {{ error$ | async | translate }}</p>
		}
		@if (inactivity()) {
			<p class="message inactive">{{ "auth.errors.timed_out" | translate }}</p>
		}
	</ic-organisation-form>
</ic-auth-wrapper>
